module.exports = __webpack_public_path__ + "static/media/alingsasvapen.ecab9240.png";